import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'agricultural',
    loadChildren: () => import('./modules/agricultural/agricultural.module').then(m => m.AgriculturalModule)
  },
  {
    path: 'tourist',
    loadChildren: () => import('./modules/tourist/tourist.module').then(m => m.TouristModule)
  },
  {
    path: 'bread-and-salt',
    loadChildren: () => import('./modules/bread-and-salt/bread-and-salt.module').then(m => m.BreadAndSaltModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
